/*
  NAVEE 定制：Testimonials 作者图片导航条。
  - 把所有作者图片排成一条，居中显示当前评论的图片，左右露出上/下一条（带灰色遮罩）。
  - 点击任意缩略图切换到对应评论（调用主题 <slide-show> 的 setActiveSlide）。
  - 通过监听 .slideshow__slide 的 .is-active 变化保持与幻灯片同步（箭头/圆点/自动播放都能同步）。
*/
(function () {
  function initNav(nav) {
    var track = nav.querySelector('.testimonials__imgnav-track');
    var thumbs = Array.prototype.slice.call(nav.querySelectorAll('.testimonials__imgnav-thumb'));
    if (!track || thumbs.length === 0) return;

    var slideShow = nav.closest('slide-show');
    var slides = slideShow
      ? Array.prototype.slice.call(slideShow.querySelectorAll('.slideshow__slide'))
      : [];

    var activeIndex = 0;

    function currentActiveFromSlides() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return activeIndex;
    }

    function centerActive() {
      var thumb = thumbs[activeIndex];
      if (!thumb) return;
      var offset = thumb.offsetLeft + thumb.offsetWidth / 2 - nav.clientWidth / 2;
      track.style.transform = 'translateX(' + (-offset) + 'px)';
    }

    function render() {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === activeIndex);
        t.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
      });
      centerActive();
    }

    function goTo(index) {
      if (index < 0 || index >= thumbs.length) return;
      activeIndex = index;
      // Drive the theme slideshow if it's initialised (multi-slide only).
      if (slideShow && typeof slideShow.setActiveSlide === 'function') {
        slideShow.setActiveSlide(index);
      }
      render();
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    // Keep in sync with any slideshow navigation (arrows / dots / autoplay / swipe).
    if (slides.length) {
      var observer = new MutationObserver(function () {
        var idx = currentActiveFromSlides();
        if (idx !== activeIndex) {
          activeIndex = idx;
          render();
        }
      });
      slides.forEach(function (slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }

    // Re-center on reflow. Thumbs use width:auto, so their positions aren't known
    // until images load — the track's content width changes then, so observe it.
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { centerActive(); }).observe(track);
    }
    thumbs.forEach(function (thumb) {
      var img = thumb.querySelector('img');
      if (img && !img.complete) img.addEventListener('load', centerActive);
    });
    window.addEventListener('resize', centerActive);
    window.addEventListener('load', centerActive);

    activeIndex = currentActiveFromSlides();
    render();
    // A tick later, once layout/images have settled.
    requestAnimationFrame(centerActive);
  }

  function init() {
    document.querySelectorAll('[data-testimonials-imgnav]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
